export enum NegotiationStatusEnum {
  SUGGESTED = null,
  TRADING = 1,
  HIRED,
  DISCARDED,
  GOT_IN_TOUCH,
  NOT_TRADING,
}

export const SUGGESTED_TAB = 0;
export const TARRIF_TAB = 1;
export const TARIFF_URL = 'tarifa';

export const TABS_TRUCKER_STATUS_MAP: { [key: string]: NegotiationStatusEnum[] } = {};

TABS_TRUCKER_STATUS_MAP[SUGGESTED_TAB] = [
  NegotiationStatusEnum?.SUGGESTED,
  NegotiationStatusEnum?.GOT_IN_TOUCH,
  NegotiationStatusEnum?.NOT_TRADING,
];

export type TActiveTab = typeof SUGGESTED_TAB;

export type TTabsState = {
  activeTab: number;
};

export const TABS: { [key: string]: number } = {
  sugeridos: SUGGESTED_TAB,
  tarifa: TARRIF_TAB,
};
